// extracted by mini-css-extract-plugin
export default {"prosperExWrapper":"ProsperEx_prosperExWrapper__CXDIi","prosperExMainContainer":"ProsperEx_prosperExMainContainer__q6Hvd","exCardWrapper":"ProsperEx_exCardWrapper__mYVLE"};